<template>
  <v-layout>
    <v-dialog v-model="dialog_ativo" persistent width="670" content-class="bra-20">
      <v-card>
        <v-card-title class="pt-5 pb-4">
          <span>Relatório de pedido Cisspoder</span>
          <v-spacer />
          <v-btn class="mr-n1" icon @click="fechar">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="mt-1">
          <v-select
            v-model="editedItem.fornecedor"
            :items="selects.fornecedores"
            chips
            label="Selecione o Fornecedor*"
            height="10"
            outlined
            item-value="idfornecedor"
            item-text="razao_social"
            :error-messages="fornecedorErrors"
          >
            <template #item="{item, on, attrs}">
              <v-list-item v-on="on" v-bind="attrs">
                <span v-text="item.razao_social" class="font-12" />

                <v-spacer />

                <v-chip v-if="item.padrao" outlined small>Padrão</v-chip>
              </v-list-item>
            </template>
          </v-select>

          <v-checkbox v-model="editedItem.fornecedor_padrao" dense hide-details class="mb-5 mt-n3 ml-n2">
            <template #label>
              <span class="pl-1 font-14">Tornar este fornecedor o padrão para este fabricante</span>
            </template>
          </v-checkbox>

          <div class="d-flex">
            <div style="width: 50%" class="pr-2">
              <v-select
                v-model="editedItem.parcelas"
                :items="selects.parcelas"
                chips
                label="Quantidade de Parcelas*"
                height="10"
                outlined
                item-value="qtde"
                item-text="qtde"
                :error-messages="parcelasErrors"
              ></v-select>
            </div>

            <div style="width: 50%" class="pl-2">
              <v-text-field
                outlined
                type="number"
                v-model="editedItem.diasIntervalo"
                label="Qtde. de dias entre parcelas*"
                style="margin-left: 5px"
                :error-messages="intervaloDiasErrors"
              ></v-text-field>
            </div>
          </div>

          <p class="ma-0 pl-1 mt-n3" v-if="infoPagamento">{{ infoPagamento }}</p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="executarRelatorio()">Gerar Relatório</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import CarrinhoAPI from "./../../../api/carrinho";
import { required } from "vuelidate/lib/validators";
import $axios from './../../../api/api.js'
import {logout} from "@/helpers";

export default {
  model:  {
    prop: "valor_modelo",
    event: "atualizacao:valor_modelo"
  },
  props: ["valor_modelo", "confirmarCotacao", "pedidoSelecionado"],
  data: () => ({
    editedItem: {
      fornecedor: "",
      parcelas: "",
      diasIntervalo: "",
      fornecedor_padrao: false
    },
    selects: {
      fornecedores: [],
      parcelas: [
        { qtde: 1 },
        { qtde: 2 },
        { qtde: 3 },
        { qtde: 4 },
        { qtde: 5 },
        { qtde: 6 },
        { qtde: 7 },
        { qtde: 8 },
        { qtde: 9 },
        { qtde: 10 },
      ],
    },
  }),
  validations: {
    editedItem: {
      fornecedor: {
        required,
      },
      parcelas: {
        required,
      },
      diasIntervalo: {
        required,
        maiorQueZero() {
          return parseInt(this.editedItem.diasIntervalo) > 0;
        },
      },
    },
  },
  computed: {
    dialog_ativo: {
      get: function () {
        return this.valor_modelo;
      },
      set: function (novo_valor) {
        return this.$emit("atualizacao:valor_modelo", novo_valor);
      }
    },
    ...mapGetters({
      grupoCompra: "usuario/getGrupoCompras",
      fornecedor: "fornecedor/getFornecedor",
    }),
    fornecedorErrors() {
      const errors = [];
      if (!this.$v.editedItem.fornecedor.$dirty) return errors;
      !this.$v.editedItem.fornecedor.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    intervaloDiasErrors() {
      const errors = [];
      if (!this.$v.editedItem.diasIntervalo.$dirty) return errors;
      else if (!this.$v.editedItem.diasIntervalo.maiorQueZero)
        errors.push("Informe um valor válido.");
      !this.$v.editedItem.diasIntervalo.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    parcelasErrors() {
      const errors = [];
      if (!this.$v.editedItem.parcelas.$dirty) return errors;
      !this.$v.editedItem.parcelas.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    infoPagamento() {
      const { parcelas, diasIntervalo } = this.editedItem;
      let info = "";

      if (parseInt(parcelas) > 0 && parseInt(diasIntervalo) > 0) {
        let count = 0;
        info = "".concat(parcelas < 10 ? "0".concat(parcelas) : parcelas);

        while (count < parcelas) {
          let dias = diasIntervalo * (count + 1);
          info = info.concat("/").concat(dias < 10 ? "0".concat(dias) : dias);
          count++;
        }
      }

      return info || "";
    },
    FORNECEDOR_SELECIONADO_OBJ() {
      return this.selects.fornecedores.find(item => String(item.idfornecedor) === String(this.editedItem.fornecedor))
    }
  },
  watch: {
    dialog_ativo: function () {
      if (this.dialog_ativo) {
        this.buscarFornecedores();
        (this.pedidoSelecionado.idfornecedor_pedido > 0) && (this.editedItem.fornecedor = this.pedidoSelecionado.idfornecedor_pedido);
      }
    },
    'pedidoSelecionado.idfornecedor': function () {
      this.selects.fornecedores.items = [];
    },
    FORNECEDOR_SELECIONADO_OBJ(obj) {
      if (!obj) return;

      this.editedItem.parcelas = obj.quantidade_parcelas > 0 ? obj.quantidade_parcelas : '';
      this.editedItem.diasIntervalo = obj.quantidade_dias_entre_parcelas > 0 ? obj.quantidade_dias_entre_parcelas : '';
    }
  },
  methods: {
    fechar: function () {
      this.editedItem.diasIntervalo = "";
      this.editedItem.parcelas = "";
      this.editedItem.fornecedor = "";
      this.editedItem.fornecedor_padrao = false;
      this.$v.$reset();
      this.dialog_ativo = false;
      this.$emit("fechar");
    },
    buscarFornecedores: function () {
      const headers = this.Helpers.iniciarRequisicao();
      const params = {
        idpedido: this.pedidoSelecionado.idpedido,
        fabricante: this.pedidoSelecionado.idfornecedor,
        analiseGrupoFornecedores: localStorage.analiseGrupoFornecedores
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        CarrinhoAPI.getFornecedorFabricante(headers, params)
          .then((response) => {
            const {token, forneFabri: fornecedores} = response.data;
            localStorage.setItem("token", token);

            this.selects.fornecedores = fornecedores.map(item => {
              item.razao_social = `${item.cnpj} - ${item.razao_social} (${item.idfornecedor})`;
              return item;
            });
          })
          .catch(logout)
      );
    },
    executarRelatorio() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      const params = {
        pedido: this.pedidoSelecionado.idpedido,
        fabricante: this.pedidoSelecionado.idfornecedor,
        fornecedor: this.editedItem.fornecedor,
        infoPagamento: this.infoPagamento,
        grupo: this.pedidoSelecionado.grupo,
        analiseGrupoFornecedores: localStorage.analiseGrupoFornecedores
      };

      if (this.pedidoSelecionado.status === "AB" && this.confirmarCotacao) {
        this.$emit("abrirCotacao", params);
      }

      const url = $axios.defaults.baseURL
        + "/pedidos-compra/exportacao/cisspoder?"
        + `pedido=${params.pedido}`
        + `&fornecedor=${params.fornecedor}`
        + `&fabricante=${params.fabricante}`
        + `&quantidade_parcelas=${this.editedItem.parcelas}`
        + `&quantidade_dias_entre_parcelas=${this.editedItem.diasIntervalo}`
        + `&infoPagamento=${params.infoPagamento}`
        + `&grupo=${params.grupo}`
        + `&analiseGrupoFornecedores=${params.analiseGrupoFornecedores}`
        + `&fornecedor_padrao=${this.editedItem.fornecedor_padrao ? 'S' : 'N'}`
        + `&usuario=${localStorage.getItem("id")}`;

      this.fechar();

      window.open(url, "_blank");
      this.$emit("relatorio-gerado", {});
    },
  },
};
</script>
